export default __webpack_public_path__ + "e995dde87f30e24d75c9cf5320e91aef.svg";